function Brands() {
  return <div>Brands</div>;
}

export default Brands;
